const { cloneDeep } = require('lodash');

const buttonState = {
    DEFAULT: 'DEFAULT',
    SAVED: 'SAVED',
};

class ProductSaveToListLegacyController {
    constructor($scope, $element, $state, $timeout, sessionStorage, analyticsService, savedListsService, shopperService, loginService, moveFocus) {
        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.$timeout = $timeout;
        this.sessionStorage = sessionStorage;
        this.analyticsService = analyticsService;
        this.savedListsService = savedListsService;
        this.shopperService = shopperService;
        this.loginService = loginService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        this.showDropdown = false;
        this.lastSavedList = '';
        this.buttonStates = buttonState;
        this.buttonState = buttonState.DEFAULT;
        this.pendingSaveToListStorageKey = `ProductSaveToListController:pendingSaveToList:${this.product.Stockcode}`;

        this.getSavedLists().then(() => {
            if (!this.savedListsService.getIsServiceAvailable()) {
                this.showServiceError();
            }
            this.savePendingProductToList();
            if (!this.shopperService.IsGuest) {
                this.savedListsService.getDefaultList().then((defaultList) => {
                    this.defaultListId = defaultList.ListId;
                });
            }
        });

        // Event listener for Saving Trolley as a list
        // This is needed when the user is on the Saved Lists page and the user adds a new list
        // This then needs to refresh the list of saved lists
        this.$scope.$on('savedLists:AddNewList', () => this.$timeout(() => this.getSavedLists()));
    }

    getSavedLists() {
        return this.savedListsService.getAllSavedLists().then((savedLists) => {
            this.savedLists = cloneDeep(savedLists);
        });
    }

    savePendingProductToList() {
        if (this.shopperService.IsGuest) {
            return;
        }

        this.savedListsService.getAllSavedLists().then(() => {
            const { stockcode } = this.sessionStorage.getJsonAndRemove(this.pendingSaveToListStorageKey) || {};
            if (stockcode === this.product.Stockcode) {
                this.save();
                this.moveFocus(this.$element.find('._saveToListButton'));
            }
        });
    }

    getButtonSrMessage() {
        return this.buttonState === buttonState.SAVED ? `Choose a list to save ${this.product.Name}` : `Save ${this.product.Name} to default list`;
    }

    save() {
        if (this.shopperService.IsGuest) {
            this.promptForGuest();
            return;
        }

        if (this.lastSavedList === '' && !this.showErrorMessage) {
            this.saveToList({}, false, true); // save to default list
        } else {
            this.toggleDropdown(true);
        }
    }

    saveToList(list, shouldCloseDropdown, shouldSaveToDefault) {
        this.savedListsService.getDefaultList().then((defaultList) => {
            if (shouldSaveToDefault) {
                list = defaultList;
            }

            this.lastSavedList = list.ListId === defaultList.ListId ? 'Default' : list.Name;
            this.buttonState = buttonState.SAVED;

            this.savedListsService.addListItem(list.ListId, this.product.Stockcode, this.product.DisplayQuantity, this.product.Source).then(() => {
                this.srMessage = `${this.product.Name} has been saved to ${this.lastSavedList}`;
                this.toggleDropdown(shouldCloseDropdown);
            });

            // push to tealium
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    list,
                    product: [this.product],
                },
                type: this.analyticsService.mapperTypes.customEvent.list.Add,
            });
        });
    }

    showServiceError() {
        this.showErrorMessage = true;
        this.showDropdown = false;
    }

    promptForGuest() {
        this.loginService.promptForLogin(this.loginService.LoginToSavetoListMessage, undefined, undefined, { reload: false }, () => {
            this.sessionStorage.setJson(this.pendingSaveToListStorageKey, { stockcode: this.product.Stockcode });
        });
    }

    toggleDropdown(shouldMoveFocus) {
        this.showDropdown = !this.showDropdown;

        if (this.showDropdown) {
            if (shouldMoveFocus) {
                this.moveFocus(() => this.$element.find('.productSaveToListLegacy-listItem > label').first());
            }
            $('body').on('click.productSaveToListLegacy', e => this.closeDropdownOnOutsideClick(e));
        }
    }

    closeDropdownOnOutsideClick(event) {
        if (!($(event.target).closest('wow-product-save-to-list-legacy')[0] === this.$element[0])) {
            this.showDropdown = false;
            this.$scope.$apply();
            $('body').off(event);
        }
    }

    isDefaultList(listId) {
        return this.defaultListId === listId;
    }

    $onDestroy() {
        $('body').off('click.productSaveToListLegacy');
    }
}


ProductSaveToListLegacyController.$inject = ['$scope', '$element', '$state', '$timeout', 'SessionStorageWrapper', 'AnalyticsService', 'SavedListsService', 'ShopperService', 'LoginService', 'MoveFocus'];

const productSaveToListLegacyComponentDefinition = {
    bindings: {
        product: '<',
    },
    controller: ProductSaveToListLegacyController,
    template: require('./product-save-to-list-legacy.component.html').trim(),
};

module.exports = {
    ProductSaveToListLegacyController,
    productSaveToListLegacyComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/productsavetolist/product-save-to-list-legacy.component.js